<template>
  <sc-modal :active.sync="showAboutModal" @close="handleClose">
    <sc-modal-card :title="modal.about.title">
      <template slot="body">



        <sc-tabs>

          <sc-tab-item label="Sobre" icon="file">
            <p class="modal_about__field">
                <strong>Descrição:</strong>
                {{ this.selectedApp ? this.selectedApp.description : "" }}
              </p>

              <p class="modal_about__field">
                <strong>Categoria:</strong>
                {{ this.selectedApp ? this.selectedApp.category : "" }}
              </p>

              <p v-if="this.selectedApp.installed" class="modal_about__field">
                <strong>ID Instalação:</strong>
                {{ this.selectedApp ? this.selectedApp.installation_id : "" }}
              </p>
              
             <div v-if="this.selectedApp.public_doc !== 'Não informada.'" class="modal_about__field">
                 <a :href="this.selectedApp.public_doc" target="_blank"> Documentação </a>
            </div>
          </sc-tab-item>

        </sc-tabs>

      </template>
    </sc-modal-card>
  </sc-modal>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import {
  ScModal,
  ScModalCard,
  ScField,
  ScTabs,
  ScTabItem,
  ScButton,
  ScInput,
  ScTaginput,
  ScToast,
  ScTable,
  ScTag,
} from "@intelipost-js/secure-components";

const { mapState, mapActions } = createNamespacedHelpers(
  "integrations/integrationsHome"
);

export default {
  name: "iplink-modal-about",

  data() {
    return {
      modal: {
        about: {
          title: "Sobre o aplicativo",
          showModal: false,
        },
      },
      dynamicForm: {
        model: {},
        schema: {
          type: "object",
          required: [],
          properties: {},
        },
        uiSchema: [],
      },
    };
  },

  computed: {
    ...mapState(["showAboutModal", "selectedApp", "appConfig"]),
  },

  methods: {
    ...mapActions(["showAboutModalAction", "getAppById"]),

    handleClose() {
      this.showAboutModalAction(false);
    },

    loadFieldsConverted(app) {

      if (this.isValid(app)) {
        const schema = JSON.parse(app.schemaBased);

        const schemaConverted = {
          required: [],
          properties: {},
          uiSchema: [],
        };

        schema.fields.forEach((field) => {
          schemaConverted.uiSchema.push({
            component: ScField,
            model: field.name,
            fieldOptions: {
              attrs: {
                label: field.name,
                class: ["margin-bottom: 0"],
              },
            },
          });

          field.type === "array" || field.type === "map"
            ? this.fieldIsArray(schemaConverted, field)
            : this.fieldIsStringOrNumber(schemaConverted, field);

          if (field.required) {
            schemaConverted.required.push(field.name);
          }
        });

        this.applyConfigToDynamicModal(schemaConverted);
      }
    },

    isValid(app) {
      if (app !== undefined) {
        if (app.schemaBased !== undefined) {
          return true;
        }
        return false;
      }
      return false;
    },

    fieldIsArray(schemaConverted, field) {

      const appConfigById = JSON.parse(this.appConfig.app_config)

      schemaConverted.properties[field.name] = {
        type: "array",
        items: {
          type: "string",
        },
      };

      const fieldName = field.name;

      const columns = [
        {
          field: 'id',
          label: 'ID',
        },
        {
          field: fieldName,
          label: fieldName,
        }
      ]

      let data = [];

      for (var i = 0; i < appConfigById[fieldName].length; i++) {

        data.push({
          'id': i, [fieldName]: appConfigById[fieldName][i]
        })
      }


      schemaConverted.uiSchema.push({
        component: ScTable,
        model: field.name,
        fieldOptions: {
          class: ["form-control"],
          on: ["input"],
          attrs: {
            model: "fsdfs",
            placeholder: "Aperte Enter para inputar o valor",
          },
          props: {
            data: data,
            columns: columns,
            placeholder: `placeholder of ${field.name}`,
          },
        },
      });

    },

    fieldIsStringOrNumber(schemaConverted, field) {

      const appConfigById = JSON.parse(this.appConfig.app_config)

      schemaConverted.properties[field.name] = {
        type: field.type,
        minLength: 1,
      };

      schemaConverted.uiSchema.push({
        component: ScInput,
        model: field.name,
        fieldOptions: {
          class: ["form-control"],
          on: ["input"],
          attrs: {
            disable: true,
          },
          props: {
            disable: true,
            value: appConfigById[field.name],
            placeholder: `placeholder of ${field.name}`,
          },
        },
      });
    },

    applyConfigToDynamicModal(schemaConverted) {
      this.dynamicForm.uiSchema = schemaConverted.uiSchema;
      this.dynamicForm.schema.properties = schemaConverted.properties;
      this.dynamicForm.schema.required = schemaConverted.required;
    },

  },

  mounted() {
    this.getAppById(this.selectedApp.id)

    if (this.appConfig !== null) {
      this.loadFieldsConverted(this.selectedApp);
    }

  },

  components: {
    ScModal,
    ScModalCard,
    ScField,
    ScTabs,
    ScTabItem,
    ScButton,
    ScField,
    ScInput,
    ScTaginput,
    ScToast,
    ScTable,
    ScTag,
  },
};
</script>

<style lang='scss'>
@import "~@intelipost-js/secure-ui/src/scss/variables";

.page-integrations {

  .modal_about__field {
    margin-bottom: 1rem;
  }

}
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-integrations/components/modal/about/ModalAbout.vue